import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { ElementType } from 'react'

type GovUKTypographyVariant =
  | 'heading-xl'
  | 'heading-l'
  | 'heading-m'
  | 'heading-s'
  | 'body'
  | 'body-l'
  | 'body-s'
  | 'lead'
  | 'caption'

const variantConfig: Record<
  GovUKTypographyVariant,
  { className: string; tag: ElementType }
> = {
  'heading-xl': { className: 'govuk-heading-xl', tag: 'h1' },
  'heading-l': { className: 'govuk-heading-l', tag: 'h2' },
  'heading-m': { className: 'govuk-heading-m', tag: 'h2' },
  'heading-s': { className: 'govuk-heading-s', tag: 'h3' },
  body: { className: 'govuk-body', tag: 'p' },
  'body-l': { className: 'govuk-body-l', tag: 'p' },
  'body-s': { className: 'govuk-body-s', tag: 'p' },
  lead: { className: 'govuk-body-l', tag: 'p' },
  caption: { className: 'govuk-caption-m', tag: 'span' },
}

interface GovUKTypographyProps extends React.HTMLAttributes<HTMLElement> {
  variant: GovUKTypographyVariant
  component?: ElementType
  marginBottom?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
  captionSize?: 's' | 'm' | 'l' | 'xl'
}

export function GovUKTypography({
  variant,
  component,
  marginBottom,
  captionSize,
  className,
  children,
  ...props
}: GovUKTypographyProps) {
  const config = variantConfig[variant]
  const Tag = component ?? config.tag

  const baseClass =
    variant === 'caption' && captionSize
      ? `govuk-caption-${captionSize}`
      : config.className

  const classes = [
    baseClass,
    marginBottom !== undefined && `govuk-!-margin-bottom-${marginBottom}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  )
}
